import {
  BaseService,
  Body,
  DELETE,
  GET,
  Headers,
  Multipart,
  Part,
  PATCH,
  Path,
  POST,
  Response,
  ResponseType
} from 'ts-retrofit';
import type {PartDescriptor} from 'ts-retrofit';
import {ACCEPT_JSON} from '../../config';
import {ToData, ToListedResponse} from '../../rest-api-hydratator-decorators';
import {Movie, MovieGenre} from '../../../../models/vision/movie';
import {ListedResponse} from '../../../../models/hydratator/listed-response';
import {FilterMoviesRequest} from '../../../../models/requests/vision/filter-movies.request';
import {BodyRequest} from '../../../../models/body-request';
import {
  MovieImportCommitRequest,
  MovieImportCommitResponse,
  MovieImportMigrationResponse,
  MovieImportUploadResponse
} from '../../../../models/vision/movie-import/movie-import-migration-response';

const base = 'movies';

export class MoviesApiService extends BaseService {
  @POST(`/${base}/filter`)
  @Headers({...ACCEPT_JSON})
  @ToListedResponse(Movie)
  async filter(@Body filter: FilterMoviesRequest): Promise<Response<ListedResponse<Movie>>> {
    return <Response>{};
  }

  @POST(`/${base}`)
  @Headers({...ACCEPT_JSON})
  @ToData(Movie)
  async save(@Body movie: Movie): Promise<Response<Movie>> {
    return <Response>{};
  }

  @GET(`/${base}/catalogue/import/{migrationId}`)
  @Headers({...ACCEPT_JSON})
  @ToData(MovieImportMigrationResponse)
  async importMigration(@Path('migrationId') migrationId: string): Promise<Response<MovieImportMigrationResponse>> {
    return <Response>{};
  }

  @POST(`/${base}/catalogue/import`)
  @Multipart
  @ToData(MovieImportUploadResponse)
  async importCatalogue(@Part('file') file: PartDescriptor<File>): Promise<Response<MovieImportUploadResponse>> {
    return <Response>{};
  }

  @POST(`/${base}/catalogue/import/{migrationId}`)
  @Headers({...ACCEPT_JSON})
  @ToData(MovieImportCommitResponse)
  async commitImport(@Path('migrationId') migrationId: string,
                     @Body request: MovieImportCommitRequest): Promise<Response<MovieImportCommitResponse>> {
    return <Response>{};
  }

  @GET(`/${base}/{id}`)
  @Headers({...ACCEPT_JSON})
  @ToData(Movie)
  async byId(@Path('id') id: number): Promise<Response<Movie>> {
    return <Response>{};
  }

  @PATCH(`/${base}/{id}/published`)
  @Headers({...ACCEPT_JSON})
  @ToData(Movie)
  async updatePublished(@Path('id') id: number, @Body published: BodyRequest<boolean>): Promise<Response<Movie>> {
    return <Response>{};
  }

  @DELETE(`/${base}/{id}`)
  @Headers({...ACCEPT_JSON})
  @ToData(Movie)
  async deleteById(@Path('id') id: number): Promise<Response<Movie>> {
    return <Response>{};
  }
}
